import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
import Modal from "react-modal";

const FarmInspcectionList = (props) => {
  const { addForm, update } = props;

  const [data, setData] = useState("");
  const [farmInspectionId, setFarmInspectionId] = useState();
  const [docurl, setDocUrl] = useState(false);

  const viewPdf = (itemId) => {
    //console.log(itemId);
    setDocUrl("https://www.orimi.com/pdf-test.pdf");

    setFarmInspectionId(itemId);
  };

  const { sendRequest: getFarmInspection } = useHttp();

  const getData = () => {
    getFarmInspection(
      {
        url: `/api/farmInspection/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log(data);
        const sortedData =
          data.farmInspection &&
          data.farmInspection.sort(
            (a, b) => b.farmInspectionId - a.farmInspectionId
          );

        setData(sortedData);
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const { sendRequest: deleteFarmInspection } = useHttp();

  const deleteData = (e, farmInspectionId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Farm Inspection detail?",
      onOk() {
        const data = {
          farmInspectionId: farmInspectionId,
        };

        deleteFarmInspection(
          {
            url: "/api/farmInspection/",
            body: data,
            method: "DELETE",
          },
          (res) => {
            //console.log(res);
            toast.success("Farm Inspcection Deleted Successfully");
            getData();
          }
        );
      },
      onCancel() {},
    });
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px", // Adjust the width as needed
      height: "80%",
      minHeight: "450px",
      overflow: "auto",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    // //console.log(data);

    const Id = data && data.farmInspectionId;

    getFarmInspection(
      {
        url: `/api/farmInspection/?orgId=${localStorage.getItem(
          "orgId"
        )}&farmInspectionId=${Id}`,
      },
      (res) => {
        //console.log(res);
        setSelectedData(res.farmInspection);
      }
    );

    //  setSelectedData(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Farm Inspcection</label>
          </div>

          <div className="col-6 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Farm Inspcection
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Inspection Date</th>
                          <th>Doc No</th>
                          <th>Executive Name</th>
                          <th>Inspector Name</th>
                          <th>Farmer Name</th>
                          <th>Plot Name</th>
                          <th>Crop Name</th>
                          <th>Variety Name</th>

                          <th>Edit</th>
                          <th>Delete</th>
                          <th>View</th>
                          <th>Pdf</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.farmInspectionDate}</td>
                                <td>{itm.docNo}</td>
                                <td>{itm.farmInspectionBy}</td>
                                <td>{itm.inspectorName}</td>
                                <td>{itm.farmerName}</td>
                                <td>{itm.plotName}</td>
                                <td>{itm.cropName}</td>
                                <td>{itm.varietyName}</td>
                                <td>
                                  <button
                                    onClick={() => {
                                      props.addForm(true);
                                      props.update(itm);
                                    }}
                                    className="btn"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={(e) => deleteData(e, itm)}
                                    className="btn"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(itm)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
       
          {selectedData && (
            <div className="mx-3">
            <div className="">
              <h3 className="card-title">Farm Inspcection Details</h3>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setIsModalOpen(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>
            </div>
  
              <div className="row">
                <p className="col-md-6">
                  Date: {selectedData.farmInspectionDate}
                </p>
                <p className="col-md-6">Doc No:{selectedData.docNo}</p>
              </div>
              <div className="row">
                <p className="col-md-6">
                  Executive Name: {selectedData.employeeName}
                </p>
                <p className="col-md-6">
                  Framer Name: {selectedData.farmerName}
                </p>
              </div>
              <div className="row">
                <p className="col-md-6">Plot Name: {selectedData.plotName}</p>
                <p className="col-md-6">Crop Name: {selectedData.cropName}</p>
              </div>
              <div className="row">
                <p className="col-md-6">
                  Variety Name: {selectedData.varietyName}
                </p>
                <p className="col-md-6">
                  Inspector Name: {selectedData.inspectorName}
                </p>
              </div>
              <div className="row">
                <p className="col-md-6">
                  Inspector Mobile: {selectedData.inspectorMobileNo}
                </p>
                <p className="col-md-6">
                  Inspector Email Id: {selectedData.inspectorEmailId}
                </p>
              </div>
  
            
              <h5 className="card-title">Farm Inspection Details</h5><br/>
              <table className="table table-bordered table-sm text-center">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Compliance Head Name</th>
                    <th>Control Type</th>
                    <th>Observation</th>
                    <th>Justification</th>
                    <th>Compliance Field Name</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedData.farmInspectionDetail &&
                    selectedData.farmInspectionDetail.map((itm, i) => {
                      return (
                        <tr key={i} className="cursor-pointer">
                          <td>{i + 1}</td>
                          <td>{itm.complianceHeadName}</td>
                          <td>{itm.controlType}</td>
                          <td>{itm.observation}</td>
                          <td>{itm.justification}</td>
                          <td>{itm.complianceFieldName}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          )}
        </Modal>
    </>
  );
};

export default FarmInspcectionList;
